import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {
  Alert,
  AlertController,
  Content,
  Loading,
  LoadingController,
  Navbar,
  NavController,
  NavParams,
  Platform,
  Popover,
  PopoverController,
  Slides
} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";
import {AppConfigPage} from "../app-config/app-config";
import {CycleCountService} from "../../providers/cyclecount.service";
import {VizixService} from "../../providers/vizix.service";
import {DepartmentsZones, ZoneType} from "../../models/zoneDeptRelation";
import {CycleCountItemResponse} from "../../models/CycleCountItemResponse";
import {CycleCountRemainingGroup} from "../../models/CycleCountRemainingGroup";
import {CycleCountRemainingItem} from "../../models/CycleCountRemainingItem";
import {ReaderService} from "../../providers/reader.service";
import {TagReadResponse} from "../../models/reader-model/tagReadResponse";
import {PadUpcPipe} from "../../pipes/validate-tag/pad-upc";
import {PopoverCycleCountDetailsPage} from "../popover-cyclecount-details/popover-cyclecount-details";
import {PopoverCyclecountGeigerPage} from "../popover-cyclecount-geiger/popover-cyclecount-geiger";
import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";
import {SimulatorService} from "../../providers/simulator.service";
import {VizixEventService} from "../../providers/vizix.event.service";
import {
  CYCLE_COUNT_ALREADY_UPLOADING,
  END_POINT_MODE_THING_BRIDGE,
  ErrorCode,
  NAV_PARAM_FILTERED_RESPONSE,
  NAV_PARAM_SELECTED_FILTERS,
  NO_INTERNET_CONNECTION,
  PAGE_SIZE,
  READER_MODE_MULTIPLE,
  RETURN_PAGE_CYCLE_COUNT,
  STORAGE_READER_SOUND_LEVEL,
  THING_TYPE_VIZIX_EVENT,
  UNKNOWN_ERROR,
  VIZIX_EVENT_ID_END_CYCLE_COUNT,
  VIZIX_EVENT_ID_PROCESSING_CYCLE_COUNT,
  VIZIX_EVENT_ID_RETRIEVE_CYCLE_COUNT,
  VIZIX_EVENT_ID_START_CYCLE_COUNT,
  VizixEventAction,
  VizixEventActivity,
  VizixEventCategory,
  VizixEventEventType,
  VizixEventSubCategory
} from "../../app/app.constants";
import {DeviceSelectPage} from "../device-select/device-select";
import {ErrorResponse} from "../../models/ErrorResponse";
import {Subscription} from "rxjs/Subscription";
import {InsomniaService} from "../../providers/insomnia.service";
import {LastDetectTag} from "../../models/LastDetectTag";
import {PopoverDetailsPage} from '../popover-details/popover-details';
import {FormatDataTypePipe} from "../../pipes/format-data-type/format-data-type";
import {NativeAudio} from "@ionic-native/native-audio";
import {Storage} from "@ionic/storage";
import {PopoverCyclecountProgressPage} from "../popover-cyclecount-progress/popover-cyclecount-progress";
import {TableScriptReportResponse} from '../../models/TableScriptReportResponse';

@Component({
  selector: 'page-cycle-count-detail',
  templateUrl: 'cycle-count-detail.html',
  providers: [PadUpcPipe, FormatDataTypePipe]
})
export class CycleCountDetailPage {

  private tag: string = '[CYCLE_COUNT_DETAIL]';


  // This object will have the following structure:
  // {string: CycleCountRemainingGroup, string, CycleCountRemainingGroup ...}
  // With the values:
  // {SKU_1: CycleCountRemainingGroup_1, SKU_2, CycleCountRemainingGroup_2 ...}
  remainingItemGroupArray: Array<CycleCountRemainingGroup> = [];
  remainingItemGroupArrayObservable: Observable<Array<CycleCountRemainingGroup>>;
  remainingItemGroupArrayObserver: Observer<Array<CycleCountRemainingGroup>>;
  remainingItemGroupArrayToShow: Array<CycleCountRemainingGroup> = [];

  readCount = 0;
  totalReadsCount = 0;
  expectedCount = 0;
  remainingCount = 0;
  toSyncCount = 0;
  oversCount = 0;
  progress = 0;

  //DepartmentZones values
  private selectedDepartment: DepartmentsZones;
  private selectedZone: ZoneType;

  alertSaveCycleCountAcceptanceCriteria: Alert;
  alertSaveCycleCount: Alert;
  alertCycleCountUploadedSuccessfully: Alert;
  alertCycleCountSavedLocally: Alert;
  alertCycleCountError: Alert;
  alertReaderError: Alert;
  alertReportError: Alert;
  alertReaderDisconnectedError: Alert;
  alertServerError: Alert;
  alertNoInformationFoundError: Alert;
  alertIncompleteUploadError: Alert;
  alertServerProcessingError: Alert;
  alertReaderNotConnectedError: Alert;
  alertCycleCountAlreadyUploadingError: Alert;
  alertCycleCountNoInternetError: Alert;

  readerDisconnectSubscription: Subscription;

  popoverProgress: Popover;
  popoverDetails: Popover;
  showDim = false;
  loading: Loading;

  isTriggerPulled = false;
  isInventory = false;
  isGeiger = false;

  isPopPageActive: boolean = false; // Used to prevent multiple 'pop' calls

  // Maps and Arrays to compare tags read by the sled
  remainingMap: Map<string, CycleCountItemResponse> = new Map(); // <SKU, ItemObject>
  totalReadsList: Array<string> = []; // Read EPCs to ignore
  oversList: Array<string> = []; // Read EPCs to ignore
  totalReadsPositionsMap: Map<string, number> = new Map(); // Read EPCs to ignore
  initialTotalReadsList: Array<string> = []; // Initial Read EPCs to ignore (From report)
  sgtinMap: Map<string, string>; // <UPC, SKU>
  gtinMap: Map<string, string>; // <EPC, SKU>
  qtyMap: Map<string, number>; // <SKU, QTY>

  knownTags: Array<string> = [];
  unknownTags: Array<string> = [];
  tagsToSync: Array<string> = [];

  toSearchInventoryList: Array<string> = [];
  lastDetectTime: Map<string, number> = new Map();
  isAlertShowing: boolean = false;
  timerTriggerPulled: any;

  isSoundTagReadReady: boolean;
  soundTagRead: string = "tagRead";
  isDeviceBeepSoundEnabled: boolean = true;
  isSoundTagReadStopped: boolean = true;

  uuid: string = '';
  username: string = '';

  isDragging: boolean = false;

  isNextRetrieveEnabled: boolean = false;

  isFirstSlideShowing: boolean = true;
  filteredResponse: TableScriptReportResponse;
  selectedFilters: { label: string, value: string }[];

  remainingColumnLabel: string = '';

  isExpectedResultLoaded: boolean = false;

  private triggerListenerSubscription: Subscription;

  @ViewChild(Content) content: Content;
  @ViewChild(Navbar) navBar: Navbar;
  @ViewChild(Slides) slides: Slides;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translate: TranslateService,
              private cycleCountService: CycleCountService,
              private vizixService: VizixService,
              private cdr: ChangeDetectorRef,
              private popoverCtrl: PopoverController,
              private alertCtrl: AlertController,
              private loadingCtrl: LoadingController,
              private readerService: ReaderService,
              private padUpc: PadUpcPipe,
              private storage: Storage,
              private platform: Platform,
              private nativeAudio: NativeAudio,
              private simulatorService: SimulatorService,
              private vizixEventService: VizixEventService,
              private _insomniaService: InsomniaService) {
    this.initParams();
    this.initBackButton();
  }

  ionViewDidLoad() {
    // Always purge tags
    this.purgeTags();

    this.initAlerts();

    this.reloadCycleCountScreen();
  }

  initParams() {
    this.selectedZone = this.navParams.get('selectedZone');
    this.selectedDepartment = this.navParams.get('selectedDepartment');
    this.filteredResponse = this.navParams.get(NAV_PARAM_FILTERED_RESPONSE) || null;
    this.selectedFilters = this.navParams.get(NAV_PARAM_SELECTED_FILTERS) || [];
  }

  initBackButton() {
    // Init Back button
    this.platform.ready().then((readySource) => {
      this.platform.registerBackButtonAction(() => {
        this.goBack();
      });
    });
  }

  /**
   *
   *  INIT POPOVERS METHODS
   *
   */

  initShowGeigerPopover(epc: string) {
    if (!this.isAlertShowing) {
      this.popoverProgress = this.popoverCtrl.create(PopoverCyclecountGeigerPage,
        {
          title: epc
        }, {
          enableBackdropDismiss: false,
          showBackdrop: true
        });
      this.isAlertShowing = true;
      this.popoverProgress.present();
      this.popoverProgress.onWillDismiss(() => {
        console.log(this.tag, 'Setting isGeiger value to false');
        this.isGeiger = false;
        this.isAlertShowing = false;
        this.showDim = false;
        this.initReaderRFID(); // If the popover is dismissed, then init Cycle Count reader mode again
      });
    }
  }

  initShowPopover(title: string, array: Array<string>) {
    if (!this.isAlertShowing) {
      // Initialize popoverDetails with the new product status list and the current status
      this.popoverDetails = this.popoverCtrl.create(PopoverCycleCountDetailsPage,
        {
          title: title,
          array: array
        }, {showBackdrop: true, cssClass: 'details-popover'});
      this.showDim = true;
      this.isAlertShowing = true;
      this.popoverDetails.present(); // Without event {ev: event}, the popoverDetails shows in the middle
      this.popoverDetails.onWillDismiss(selectedItem => {
        this.isAlertShowing = false;
        if (selectedItem != null) {
          this.showDim = false;
          // Init geiger with the current item
          this.initReaderGeiger(new CycleCountRemainingItem().fromSingleEpc(selectedItem));
        }
      });
    }
  }

  /**
   *
   *  INIT ALERTS METHODS
   *
   */

  initAlerts() {
    this.initAlertSaveCycleCount(false);
    this.initAlertCycleCountUploadedSuccessfully();
    this.initAlertCycleCountUploadError();
    this.initAlertCycleCountSavedLocally();
    this.initAlertNoInformationFoundError();
    this.initAlertReaderError();
    this.initAlertReportError();
    this.initAlertServerProcessingError();
    this.initAlertReaderDisconnectedError();
    this.initAlertReaderNotConnectedError();
    this.initAlertServerError();
    this.initAlertCycleCountAlreadyUploadingError();
    this.initAlertCycleCountNoInternetError();
    this.initAlertIncompleteUploadError(0);
  }

  // Alert that shows when user clicks on Save Cycle Count button
  initAlertSaveCycleCount(exitAfterSave: boolean, fromTemplateBackButton?: boolean) {

    let buttons = [];

    buttons.push({
      text: this.translate.instant('cycle_count.alerts.save_cycle_count.ok'),
      handler: () => {
        this.isAlertShowing = false;
        this.simulateTriggerReleased();
        this.saveCycleCount().then(() => {
          if (exitAfterSave || fromTemplateBackButton) {
            this.closeAllPopupsAndPop();
          } else {
            this.reloadCycleCountScreen(true); // Update details with delay
          }
        });
        this.initAlertSaveCycleCount(false); // We call this recursively because the alert is destroyed on dismiss
      }
    });

    if (!exitAfterSave) {
      buttons.push({
        text: this.translate.instant('cycle_count.alerts.save_cycle_count.cancel'),
        handler: () => {
          this.isAlertShowing = false;
          this.initAlertSaveCycleCount(false); // We call this recursively because the alert is destroyed on dismiss
        }
      });
    }

    buttons.push({
      text: this.translate.instant('cycle_count.alerts.save_cycle_count.exit'),
      handler: () => {
        this.isAlertShowing = false;
        this.simulateTriggerReleased();
        // if(!this.exitAfterSave){
        this.closeAllPopupsAndPop();
        this.initAlertSaveCycleCount(false); // We call this recursively because the alert is destroyed on dismiss
        // } else {
        //   this.goBack(true);
        // }
      }
    });

    this.alertSaveCycleCount = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.save_cycle_count.title'),
      message: this.translate.instant('cycle_count.alerts.save_cycle_count.message'),
      enableBackdropDismiss: false,
      buttons: buttons
    });
  }

  // Alert that shows when Cycle Count is uploaded successfully
  initAlertCycleCountUploadedSuccessfully() {
    this.alertCycleCountUploadedSuccessfully = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.uploaded_successfully.title'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.uploaded_successfully.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.reloadCycleCountScreen(true);
            this.initAlertCycleCountUploadedSuccessfully(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when Cycle Count is uploaded successfully
  initAlertCycleCountSavedLocally() {
    this.alertCycleCountSavedLocally = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.saved_locally.title'),
      subTitle: this.translate.instant('cycle_count.alerts.saved_locally.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.saved_locally.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.reloadCycleCountScreen(true);
            this.initAlertCycleCountSavedLocally(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertCycleCountUploadError() {
    this.alertCycleCountError = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.upload_error.title'),
      message: this.translate.instant('cycle_count.alerts.upload_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.upload_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.reloadCycleCountScreen(true);
            this.initAlertCycleCountUploadError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }/*,
        {
          text: this.translate.instant('cycle_count.alerts.upload_error.cancel'),
          role: 'cancel',
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertCycleCountUploadError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }*/
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertCycleCountAlreadyUploadingError() {
    this.alertCycleCountAlreadyUploadingError = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.cycle_count_already_uploading.title'),
      message: this.translate.instant('cycle_count.alerts.cycle_count_already_uploading.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.cycle_count_already_uploading.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.reloadCycleCountScreen(true); // Add delay to update
            this.initAlertCycleCountAlreadyUploadingError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }/*,
        {
          text: this.translate.instant('cycle_count.alerts.upload_error.cancel'),
          role: 'cancel',
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertCycleCountUploadError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }*/
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertCycleCountNoInternetError() {
    this.alertCycleCountNoInternetError = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.no_internet.title'),
      message: this.translate.instant('cycle_count.alerts.no_internet.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.no_internet.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.reloadCycleCountScreen(true);
            this.initAlertCycleCountNoInternetError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }/*,
        {
          text: this.translate.instant('cycle_count.alerts.upload_error.cancel'),
          role: 'cancel',
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertCycleCountUploadError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }*/
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertReaderError() {
    this.alertReaderError = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.reader_error.title'),
      message: this.translate.instant('cycle_count.alerts.reader_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.reader_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            // this.saveCycleCountLocally();
            if (this.toSyncCount > 0) {
              // this.exitAfterSave = true;
              this.initAlertSaveCycleCount(true); // To remove CANCEL button
              this.isAlertShowing = true;
              this.alertSaveCycleCount.present();
            } else {
              this.goBack();
            }
            this.initAlertReaderError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertReportError() {
    this.alertReportError = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.report_error.title'),
      message: this.translate.instant('cycle_count.alerts.report_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.report_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.goBack();
            this.initAlertReportError();// We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when no information is found for the input tag
  initAlertNoInformationFoundError() {
    this.alertNoInformationFoundError = this.alertCtrl.create({
      title: this.translate.instant('identify_tag.alerts.no_information.title'),
      //message: this.translate.instant('identify_tag.alerts.no_information.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('identify_tag.alerts.no_information.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertNoInformationFoundError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertReaderDisconnectedError() {
    this.alertReaderDisconnectedError = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.reader_disconnected_error.title'),
      message: this.translate.instant('cycle_count.alerts.reader_disconnected_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.reader_disconnected_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            if (this.toSyncCount > 0) {
              // this.exitAfterSave = true;
              this.initAlertSaveCycleCount(true); // To remove CANCEL button
              this.isAlertShowing = true;
              this.alertSaveCycleCount.present();
            } else {
              this.goBack();
            }
            this.initAlertReaderDisconnectedError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertServerError() {
    this.alertServerError = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.server_error.title'),
      message: this.translate.instant('cycle_count.alerts.server_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.server_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.closeAllPopupsAndPop();
            this.initAlertServerError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertIncompleteUploadError(errorCount: number) {
    this.alertIncompleteUploadError = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.incomplete_upload.title'),
      message: this.translate.instant('cycle_count.alerts.incomplete_upload.message_1') + errorCount +
      this.translate.instant('cycle_count.alerts.incomplete_upload.message_2'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.incomplete_upload.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertIncompleteUploadError(0); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertServerProcessingError() {
    this.alertServerProcessingError = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.server_processing.title'),
      message: this.translate.instant('cycle_count.alerts.server_processing.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.server_processing.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.closeAllPopupsAndPop();
            this.initAlertServerProcessingError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when the reader is not connected and user tries to do something in the module
  initAlertReaderNotConnectedError() {
    this.alertReaderNotConnectedError = this.alertCtrl.create({
      title: this.translate.instant('menu_tracker_retail.alerts.error_pair.title'),
      message: this.translate.instant('menu_tracker_retail.alerts.error_pair.message'),
      buttons: [
        {
          text: this.translate.instant('menu_tracker_retail.alerts.error_pair.cancel'),
          role: 'cancel',
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertReaderNotConnectedError();
          }
        },
        {
          text: this.translate.instant('menu_tracker_retail.alerts.error_pair.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertReaderNotConnectedError();
            this.navCtrl.push(DeviceSelectPage, {'backToMenu': true, 'returnPage': RETURN_PAGE_CYCLE_COUNT});
          }
        }
      ]
    });
  }

  initShowProgressPopover() {
    if (!this.isAlertShowing) {
      this.popoverProgress = this.popoverCtrl.create(PopoverCyclecountProgressPage,
        {
          title: this.translate.instant('cycle_count.popovers.progress.title'),
        }, {
          enableBackdropDismiss: false,
          showBackdrop: true
        });
      this.isAlertShowing = true;
      this.popoverProgress.present();
      this.popoverProgress.onWillDismiss(() => {
        this.isAlertShowing = false;
        this.showDim = false;
      });
    }
  }

  private generateAndSaveVizixEvent(action: VizixEventAction,
                                    activity: VizixEventActivity,
                                    details: any,
                                    eventId: string,
                                    count?: number,
                                    isError?: boolean,
                                    errorMessage?: string,
                                    bridgeCode?: string,
                                    thingTypeCode?: string,
                                    syncSessionID?: number) {
    this.vizixEventService.getVizixEventItemBase(isError).then((vizixEvent) => {
      // To prevent collision with End event in snapshots
      if(action == VizixEventAction.PROCESSED) {
        vizixEvent.eventDate += 100;
      }

      vizixEvent.action = action;
      vizixEvent.category = VizixEventCategory.WORKFLOW;
      vizixEvent.subCategory = VizixEventSubCategory.CYCLE_COUNT;
      vizixEvent.eventType = VizixEventEventType.INFO;
      vizixEvent.activity = activity;
      vizixEvent.detail = this.vizixEventService.generateDetailsMessage(
        details ? details : (isError ? errorMessage : ''),
        this.vizixService.configurationApp.CycleCountConfiguration.ThingTypeCodeSync.value,
        this.cycleCountService.thingTypeCodeToSyncGroup, this.selectedDepartment.DeptName, this.selectedZone.name, syncSessionID);
      vizixEvent.eventId = eventId;
      vizixEvent.count = count ? count : 0;
      this.vizixEventService.recordEvent(vizixEvent, bridgeCode, thingTypeCode);
    }, (error) => {
      console.log(this.tag, 'Error getting VizixItemBase', error);
    });
  }

  reloadCycleCountScreen(success?: boolean) {
    this.loading = this.loadingCtrl.create({
      content: this.translate.instant('cycle_count.loading.reloading')
    });
    this.isAlertShowing = true;
    this.loading.onWillDismiss(() => {
      this.isAlertShowing = false;
    });
    this.loading.present();

    if (success) {
      let delay = this.vizixService.configurationApp.CycleCountConfiguration.UpdateRemainingDelay.value;
      if (delay > 0) {
        setTimeout(() => {
          this.initReaderRFID();
          this.reloadCycleCountData(true);
        }, delay * 1000);
      } else {
        this.initReaderRFID();
        this.reloadCycleCountData(true);
      }
    } else {
      this.reloadCycleCountData();
    }
  }

  initLoader(content: string, onWillDismiss?) {
    this.loading = this.loadingCtrl.create({
      content: this.translate.instant(content),
      enableBackdropDismiss: true
    });
    this.isAlertShowing = true;
    this.loading.present();
    this.loading.onWillDismiss(() => {
      this.isAlertShowing = false;
      if (this.timerTriggerPulled) {
        clearTimeout(this.timerTriggerPulled);
      }
      if (onWillDismiss) {
        onWillDismiss();
      }
    });
  }

  openInfo(remainingItem: CycleCountRemainingItem) {
    this.initShowDetailsPopover(
      this.translate.instant('cycle_count.popovers.details.title'),
      remainingItem.SKU,
      true,
      (initGeiger: boolean) => {
        if (initGeiger) {
          let triggerWasPressed = this.isTriggerPulled;

          this.initReaderGeiger(remainingItem);

          this.timerTriggerPulled = setTimeout(() => {
            if (triggerWasPressed) {
              this.simulateTriggerPulled();
            }
          }, 500);
        }
      });
  }

  reloadCycleCountData(success?: boolean) {
    if (!success) { // If it is the first time, we reset
      this.knownTags = [];
      this.unknownTags = [];
      this.remainingMap = new Map();
      this.totalReadsList = [];
      this.initialTotalReadsList = [];
      this.totalReadsPositionsMap = new Map();
    }

    let newTotalReadsList = []; // The new Total Read tags list to process

    // Get the expected items with the first report
    // This report also creates an event in Vizix, so we pass the corresponding values

    if (!success || (this.isNextRetrieveEnabled && success)) {

      const handleReportResponse = (response: TableScriptReportResponse) => {

        if (!response.isProcessing){
          // Once both reports are executed, we set the reader mode after setting the power to MAX
          this.setReaderPower(this.vizixService.configurationApp.CycleCountConfiguration.PowerLevel.value).then(readerPowerSuccess => {
            if (readerPowerSuccess) {
              console.log(this.tag, 'Table Script response', response);

              this.initReaderRFID();

              // Get the remaining list column label
              this.remainingColumnLabel = response.columnNames.length ? response.columnNames[0] : '';

              if (!success) { // If it is the first time
                if (response.overs) {
                  this.oversCount = response.overs;
                  this.oversList = response.lstOvers;
                }

                // Remaining items
                console.log(this.tag, 'Remaining Tags: ', response.data);
                for (let dataItem of response.data) {
                  this.remainingMap.set(dataItem[2], new CycleCountItemResponse().fromArray(dataItem));
                }

                // Total Read items
                for (let readTag of response.extra) {
                  this.totalReadsPositionsMap.set(readTag[0], this.totalReadsList.length);
                  this.totalReadsList.push(readTag[0]); // Add tags to ignore
                  this.initialTotalReadsList.push(readTag[0]);
                }

                if (response.extraOriginal) {
                  for (let originalReadTag of response.extraOriginal) {
                    // Only if the tag was not added already
                    if (this.totalReadsList.indexOf(originalReadTag[0]) == -1) {
                      this.totalReadsList.push(originalReadTag[0]); // Add tags to ignore
                    }
                  }
                }

                console.log(this.tag, 'Total Read Tags: ', this.initialTotalReadsList);
              } else { // If it is the second+ time

                // New Total Read items
                console.log(this.tag, 'New Total Read Tags from report: ', response.data);
                // console.log(this.tag, 'Positions map: ', this.totalReadsPositionsMap);
                for (let readTag of response.data) {
                  let positionInMap = this.totalReadsPositionsMap.get(readTag[0]);
                  // console.log(this.tag, 'Found position', positionInMap);
                  if (positionInMap || positionInMap == 0) { // Only if the tag is in the list, we ignore the tag
                    // console.log(this.tag, 'Tag', readTag, 'Found in positions map, ignoring');
                  } else { // We process the new tags that arrived as if they were read by the reader
                    // console.log(this.tag, 'Tag', readTag, 'Not found in positions map, adding to list and processing', newTotalReadsList.length);
                    this.processTag(new TagReadResponse().fromLastCycleCountReportResponse(readTag), true);
                    this.totalReadsPositionsMap.set(readTag[0], this.totalReadsList.length);
                    this.totalReadsList.push(readTag[0]); // Add tags to ignore
                    this.initialTotalReadsList.push(readTag[0]);
                    newTotalReadsList.push(readTag);
                  }
                }
                console.log(this.tag, 'Total Read Tags: ', this.initialTotalReadsList);
                console.log(this.tag, 'Processed New Total Read Tags: ', newTotalReadsList);
              }

              if (!success) { // If it is the first time, we initialize the maps as usual
                console.log(this.tag, 'Initializing the maps');
                this.initMaps();
              }

              this.initCounters(success).then((countsJSON) => {
                // Record the start of a cyclecount
                this.generateAndSaveVizixEvent(VizixEventAction.RETRIEVE,
                  VizixEventActivity.SYNC,
                  countsJSON,
                  VIZIX_EVENT_ID_RETRIEVE_CYCLE_COUNT);
              });

              this.dismissLoading();

            } else {
              console.log(this.tag, 'ERROR Set Reader Power');
              this.isAlertShowing = true;
              this.alertReaderError.present();

              this.dismissLoading();
            }
          }).catch(error => {
            console.log(this.tag, 'ERROR Set Reader Power', error);
            this.isAlertShowing = true;
            this.alertReaderError.present();

            this.dismissLoading();
          });
        } else {
          this.isAlertShowing = true;
          this.alertServerProcessingError.present();
        }

        // Report was loaded
        this.isExpectedResultLoaded = true;
      };

      if (this.filteredResponse) {
        setTimeout(() => {
          handleReportResponse(this.filteredResponse);
        }, 2000);
      } else {
        this.cycleCountService.executeCycleCountReport({
          success: success,
          storeID: String(this.vizixService.getStoreId()),
          selectedZone: this.selectedZone,
          selectedDepartment: this.selectedDepartment,
          uuid: this.uuid
        }).subscribe(handleReportResponse, (error: { message: string, code: ErrorCode }) => {
          switch (error.code) {
            case ErrorCode.REPORT_ERROR: {
              console.log(this.tag, error.message);
              this.dismissLoading();
              this.isAlertShowing = true;
              this.alertReportError.present();
              break;
            }
            case ErrorCode.SERVER_ERROR: {
              console.log(this.tag, 'error', error.message);
              this.dismissLoading();
              this.isAlertShowing = true;
              this.alertServerError.present();
              this.goBack();
              break;
            }
            case ErrorCode.UNKNOWN_ERROR: {

              break;
            }
            default: {

              break;
            }
          }
        });
      }

    } else {
      console.log(this.tag, 'Cleared screen');
      this.initCounters(success).then((countsJSON) => {
        // Record the start of a cyclecount
        this.generateAndSaveVizixEvent(VizixEventAction.RETRIEVE,
          VizixEventActivity.SYNC,
          countsJSON,
          VIZIX_EVENT_ID_RETRIEVE_CYCLE_COUNT);
      });

      this.dismissLoading();
    }
  }

  dismissLoading() {
    this.isAlertShowing = false;
    this.loading.dismiss();
  }

  /**
   *
   *    INIT MAPS AND COUNTERS
   *
   */

  // Called only when the report is executed, later we use the methods incrementKnownCount incrementUnknownCount
  initCounters(success?: boolean): Promise<any> {
    return new Promise<any>((resolve => {
      this.readCount = 0;
      this.toSyncCount = 0;

      if (!success) {
        this.totalReadsCount = this.initialTotalReadsList.length;

        // We get the remaining summing up all the QtyOnHands of all the groups:
        this.remainingCount = 0;
        for (let itemGroup of this.remainingItemGroupArray) {
          this.remainingCount += Number(itemGroup.GroupQty);
        }

        this.expectedCount = this.totalReadsCount + this.remainingCount;
        this.progress = Math.floor((this.totalReadsCount / (this.expectedCount == 0 ? 1 : this.expectedCount)) * 100);
      }

      // this.sendUpdatedCounters();
      this.cdr.detectChanges();

      console.log(this.tag, 'From Counters, initialTotalReadsList', this.initialTotalReadsList);
      console.log(this.tag, 'From Counters, totalReadsList', this.totalReadsList);

      resolve({
        totalReads: this.totalReadsCount,
        remainingCount: this.remainingCount,
        expectedCount: this.expectedCount
      })
    }));
  }

  initMaps() {
    this.remainingItemGroupArrayObservable = Observable.create((observer: Observer<Array<CycleCountRemainingGroup>>) => {
      this.remainingItemGroupArrayObserver = observer;
    });

    this.remainingItemGroupArray = [];
    this.remainingItemGroupArrayToShow = [];

    this.sgtinMap = new Map();
    this.gtinMap = new Map();
    this.qtyMap = new Map();

    for (let entry of Array.from(this.remainingMap.entries())) {
      let value = entry[1];

      this.qtyMap.set(value.SKU, Number(value.QtyOnHand));

      // Init the Remaining Items List Map
      // Check if the map already has the group (brand)
      let updated = false;
      for (let remainingGroup of this.remainingItemGroupArray) {
        if (remainingGroup.Group == value.Group) {
          remainingGroup.itemList.push(new CycleCountRemainingItem().fromCycleCountItemResponse(value));
          updated = true;
          break;
        }
      }
      if (!updated) {
        this.remainingItemGroupArray.push(new CycleCountRemainingGroup(null, null, null, null).fromCycleCountItemResponse(value));
      }

      // Init the sgtinMap, Include concatenated UPCs (two upc entries with the same sku)
      if (value.UPC) {
        if (value.UPC.split('|').length > 1) {
          for (let splitUPC of value.UPC.split('|')) {
            this.sgtinMap.set(splitUPC, value.SKU);
          }
        } else {
          this.sgtinMap.set(value.UPC, value.SKU);
        }
      }

      // TODO: TO CHECK IF MAPS ARE GENERATING OK
      // console.log(this.tag, 'SGTIN Map Keys', Array.from(this.sgtinMap.keys()));
      // console.log(this.tag, 'SGTIN Map Values', Array.from(this.sgtinMap.values()));

      // Init the gtinMap (Non SGTIN), Include concatenated EPCs (two epc entries with the same sku)
      if (value.EPC) {
        if (value.EPC.split('|').length > 1) {
          for (let splitEPC of value.EPC.split('|')) {
            this.gtinMap.set(splitEPC, value.SKU);
          }
        } else {
          this.gtinMap.set(value.EPC, value.SKU);
        }
      }

    }
    this.refreshRemainingList();

    console.log(this.tag, 'Generated Remaining Items map: ', this.remainingItemGroupArray);
    console.log(this.tag, 'Generated SGTIN map: ', this.sgtinMap);
    console.log(this.tag, 'Generated GTIN map: ', this.gtinMap);
    console.log(this.tag, 'Generated QTY map: ', this.qtyMap);
    this.cdr.detectChanges();
  }

  resetCounters() {
    this.readCount = 0;
    this.totalReadsCount = 0;
    this.expectedCount = 0;
    this.remainingCount = 0;
    this.toSyncCount = 0;
    this.progress = 0;
    this.oversCount = 0;
  }

  showUploadErrorAlert(error: ErrorResponse) {
    this.isAlertShowing = true;
    console.log(this.tag, 'Error', error);
    if (error.errorCode != null) {
      if (error.errorCode == UNKNOWN_ERROR) {
        this.alertCycleCountError.present();
      } else if (error.errorCode == NO_INTERNET_CONNECTION) {
        this.alertCycleCountNoInternetError.present();
      } else if (error.errorCode == CYCLE_COUNT_ALREADY_UPLOADING) {
        this.alertCycleCountAlreadyUploadingError.present();
      } else {
        this.alertCycleCountError.present();
      }
    } else {
      this.alertCycleCountError.present();
    }
  }

  public saveCycleCountTemplate() {
    if (this.tagsToSync.length > 0) {
      this.saveCycleCount().then(() => {
        this.reloadCycleCountScreen(true);
      });
    }
  }

  processTag(tagResponse: TagReadResponse, skipToSyncCounterUpdate?: boolean) {
    // console.log(this.tag, 'TAG: ', tagResponse);

    // First we check if the tag has a value and it is not a tag to ignore
    if (tagResponse.value && !this.isTagToIgnore(tagResponse.value)) {
      // console.log(this.tag, 'OK 1');

      // this.lastDetectTime.set(tagResponse.value, tagResponse.time);
      this.lastDetectTime.set(tagResponse.value, this.vizixService.vizixTime());

      // Second we check if the tag is SGTIN or GTIN
      let sku: string = '';

      if (tagResponse.sku) { // From LastCycleCount report
        sku = tagResponse.sku;
      } else {
        if (tagResponse.upc) { // From Reader SGTIN
          tagResponse.upc = this.padUpc.transform(tagResponse.upc);
          // console.log(this.tag, 'Testing UPC: ' + tagResponse.upc);
          sku = this.sgtinMap.get(tagResponse.upc);
          if (!sku) {
            // console.log(this.tag, 'Testing EPC: ' + tagResponse.value);
            sku = this.gtinMap.get(tagResponse.value);
          }
        } else if (tagResponse.value) { // From Reader GTIN
          // console.log(this.tag, 'Testing EPC: ' + tagResponse.value);
          sku = this.gtinMap.get(tagResponse.value);
        }
      }

      this.totalReadsList.push(tagResponse.value);
      // console.log(this.tag, 'Tag: ', tagResponse);
      if (sku && this.hasQuantityOnHands(sku)) { // Known tag

        // if(tagResponse.sku) console.log(this.tag, 'Known tag: ', tagResponse); // TODO: REMOVE LOG!
        // Save the EPC and the UPC if SGTIN
        // this.knownTags.push(tagResponse.upc ? tagResponse.value + '|' + tagResponse.upc : tagResponse.value);
        this.knownTags.push(tagResponse.value);
        if (!tagResponse.sku) this.tagsToSync.push(tagResponse.value); // Add only if the tag was read from the reader

        this.initialTotalReadsList.push(tagResponse.value);
        this.updateQuantityOnHands(sku); // Update Quantities
        this.incrementKnownCount(skipToSyncCounterUpdate); // Update Counts

        // After processed play a sound, skip if other sound is still playing
        if (this.isSoundTagReadStopped &&
          this.isSoundTagReadReady &&
          this.isDeviceBeepSoundEnabled &&
          !tagResponse.sku) {
          this.nativeAudio.play(this.soundTagRead, () => {
            this.isSoundTagReadStopped = true;
          });
        }
        this.isSoundTagReadStopped = false;

      } else { // Unknown tag
        // Check if qty is 0 to increment overs
        if (this.qtyMap.has(sku) && this.qtyMap.get(sku) == 0) {
          this.incrementOversCount();
        }

        // if(tagResponse.sku) console.log(this.tag, 'Unknown tag', tagResponse); // TODO: REMOVE LOG!
        // Save the EPC and the UPC if SGTIN
        // this.unknownTags.push(tagResponse.upc ? tagResponse.value + '|' + tagResponse.upc : tagResponse.value);
        this.unknownTags.push(tagResponse.value);
        if (!tagResponse.sku) this.tagsToSync.push(tagResponse.value); // Add only if the tag was read from the reader
        this.incrementUnknownCount(skipToSyncCounterUpdate); // Update Counts
      }
    } else { // else do nothing
      // console.log(this.tag, 'Ignored tag', tagResponse);
    }
  }

  incrementKnownCount(skipToSyncCounterUpdate?: boolean) {
    this.totalReadsCount += 1;
    if (!skipToSyncCounterUpdate) {
      this.readCount += 1;
      this.toSyncCount += 1;
    }
    this.remainingCount = this.expectedCount - this.totalReadsCount;
    this.progress = Math.floor((this.totalReadsCount / this.expectedCount) * 100);
    if (this.progress > 100) {
      this.isAlertShowing = true;
      this.alertCycleCountError.present();
    }

    // this.sendUpdatedCounters();

    this.cdr.detectChanges();
  }

  incrementUnknownCount(skipToSyncCounterUpdate?: boolean) {
    if (!skipToSyncCounterUpdate) {
      this.toSyncCount += 1;
    }

    // this.sendUpdatedCounters();

    this.cdr.detectChanges();
  }

  incrementOversCount() {
    this.oversCount += 1;
    this.cdr.detectChanges();
  }

  toggleGroup(group: CycleCountRemainingGroup) {
    group.expanded = !group.expanded;
    for (let remainingGroup of this.remainingItemGroupArray) {
      if (remainingGroup.Group == group.Group) {
        remainingGroup.expanded = group.expanded;
        if (!group.expanded) {
          group.itemList =
            remainingGroup.itemList.slice(
              0,
              PAGE_SIZE);
          group.page = 1;
        }
        break;
      }
    }

    // if(this.remainingItemGroupArrayObserver && !this.isFirstSlideShowing){
    //   this.remainingItemGroupArrayObserver.next(this.remainingItemGroupArray);
    // }
    // if(group.itemListObserver && !this.isFirstSlideShowing){
    //   group.itemListObserver.next(group.itemList);
    // }
    this.cdr.detectChanges();
  };

  showSaveCycleCountAlert() {
    this.isAlertShowing = true;
    this.alertSaveCycleCountAcceptanceCriteria.present();
  }

  goBack(fromTemplateBackButton ?: boolean) {
    if (!this.isAlertShowing && !this.isPopPageActive) {
      if (this.toSyncCount > 0) {
        this.isAlertShowing = true;
        this.initAlertSaveCycleCount(false, fromTemplateBackButton);
        this.alertSaveCycleCount.present();
      } else {
        this.closeAllPopupsAndPop();
      }
    }
    else {
      if (this.popoverDetails) {
        this.popoverDetails.dismiss();
        this.popoverDetails = null;
      }
    }
  }

  closeAllPopupsAndPop() {
    if (!this.isPopPageActive) {
      if (this.popoverDetails) {
        this.popoverDetails.dismiss();
      }
      this.navCtrl.pop();
      this.isPopPageActive = true;
    }
  }

  goToAppConfig() {
    if (!this.isTriggerPulled) {
      this.navCtrl.push(AppConfigPage, {'returnPage': RETURN_PAGE_CYCLE_COUNT});
    }
  }

  ionViewDidEnter() {

    //insomnia service with the method insomniaKeepAwakeScreen() will Prevent the screen of the mobile device from falling asleep. (Only in this screen)
    this._insomniaService.insomniaKeepAwakeScreen().subscribe(
      (response: any) => {
        console.log('[INSOMNIA PLUGIN]', response);
      }, (error) => {
        console.error('[INSOMNIA PLUGIN]', 'Error Keeping application awake');
      }
    );

    this.initReaderStatusListenerIfConnected();
    this.readerService.dynamicPowerEnable(true); // To use the power level from settings
    if(this.isExpectedResultLoaded) {
      this.initReaderRFID();
    }
    this.cdr.reattach();
    this.cdr.detectChanges();

    this.initSounds();

    this.initBackButton();
  }

  ionViewWillEnter() {

  }

  ionViewWillLeave() {
    //insomnia service with the method insomniaAllowScreenSleepAgain will screen sleep again when go to other page
    this._insomniaService.insomniaAllowScreenSleepAgain().subscribe(
      (response: any) => {
        console.log('[INSOMNIA PLUGIN]', response);
      }, (error) => {
        console.error('[INSOMNIA PLUGIN]', 'Error allowing application sleep again');
      }
    );

    this.readerService.dynamicPowerEnable(false);

    this.dismissLoading();

    this.unsubscribeAll();
    this.unloadSounds();
    //this.stopReader(); ==>won't use this method because a menu screen delay
    this.cdr.detach();
  }

  initNativeAudio(volume: number) {
    console.log(this.tag, 'Setting beep volume', volume);
    this.nativeAudio.preloadComplex(this.soundTagRead,
      'assets/sounds/beep.wav', volume, 2, 0).then(() => {
      console.log(this.tag, 'Sounds loaded successfully');
      this.isSoundTagReadReady = true;
    }, (error) => {
      console.log(this.tag, 'Error loading sounds', error);
    });
  }

  initSounds() {
    if (this.isDeviceBeepSoundEnabled) {
      this.storage.get(STORAGE_READER_SOUND_LEVEL).then((levelSound) => {
        console.log(this.tag, 'Sound Level from storage', levelSound);
        if (!levelSound && levelSound != 0) {
          this.initNativeAudio(1);
        }
        else {
          this.initNativeAudio(levelSound / 10);
        }
      }, error => {
        this.initNativeAudio(1);
      });
    }
  }

  unloadSounds() {
    this.nativeAudio.unload(this.soundTagRead);
  }

  /**************************
   *
   *      READER METHODS
   *
   * ************************
   */

  initReaderStatusListenerIfConnected() {
    this.isReaderConnected().subscribe((isConnected) => {
      this.initReaderStatusListener();
    }, () => {
      if (this.simulatorService.isSimulatorEnabled) {
        this.initReaderStatusListener();
      } else {
        // this.alertReaderNotConnectedError.present();
        // this.isAlertShowing = true;
      }
    });
  }

  private initReaderStatusListener() {
    console.log(this.tag, 'Initializing Reader Status Listener');
    this.readerDisconnectSubscription = this.readerService.setStatusListener().subscribe((response) => {
      console.log(this.tag, 'Reader status', response);
      if (response.hasOwnProperty('connected') && !response.connected) {
        console.log(this.tag, 'Reader disconnected!');
        this.isAlertShowing = true;
        this.alertReaderDisconnectedError.present();
      }
    }, (error) => {
      this.isAlertShowing = true;
      this.alertReaderError.present();
    });
  }

  initReaderTriggerListener() {
    if (this.readerService.setTriggerListener()) {
      console.log(this.tag, 'Trigger listener set');
      this.triggerListenerSubscription = this.readerService.setTriggerListener().subscribe(
        (tagResponse: any) => {
          console.log(this.tag, 'Trigger State: ', tagResponse);
          this.isTriggerPulled = tagResponse;

          if (!this.isTriggerPulled) {
            clearTimeout(this.timerTriggerPulled);
          }

          // To prevent more values to arrive to the geiger popover
          // this.readerService.isTriggerPulled = this.isTriggerPulled;

          if (!this.isTriggerPulled && !this.isInventory) { // Refresh the list when trigger is released
            this.refreshRemainingList();
          }

          if (!this.simulatorService.isSimulatorEnabled && !this.isTriggerPulled && this.isInventory) {
            this.cancelInventory().then(() => {
              this.isAlertShowing = false;
              this.loading.dismiss();

              this.simulateTriggerReleased();
            });
            this.resetGeiger();
          }

          this.cdr.detectChanges();
        }, (error) => {
          console.log(this.tag, 'Trigger State error: ', error);
          this.isAlertShowing = true;
          this.alertReaderError.present();
        }
      );
    }
  }

  initReaderRFID() {
    // We simulate release trigger first, then we init RFID mode
    // this.simulateTriggerReleased();

    this.initReaderTriggerListener();

    //if (this.platform.is('cordova')) {
    console.log(this.tag, 'Initializing rfid');
    this.readerService.initMultipleScan().subscribe(
      (tagResponse: TagReadResponse) => {
        // Tag read
        // console.log(this.tag, 'TAG: ', tagResponse);

        if (this.isTriggerPulled) {
          // console.log(this.tag, 'OK', this.toSyncCount);

          if (this.isInventory) {
            this.processTagInventory(tagResponse);
          } else {
            this.processTag(tagResponse);
          }
        }
      }, (error) => {
        console.log(this.tag, 'ERROR Reader RFID', error);
        this.isAlertShowing = true;
        this.alertReaderError.present();
      }
    );
    //}
  }

  // Sets the reader to the power percentage
  setReaderPower(powerPercentage: number): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.isReaderConnected().subscribe(() => {
        this.readerService.setReaderPower(powerPercentage, READER_MODE_MULTIPLE).subscribe(
          (response: any) => {
            if (response) {
              console.log(this.tag, 'Reader Power set to', powerPercentage);
              resolve(true);
            } else {
              resolve(false);
            }
          }, (error) => {
            console.log(this.tag, 'ERROR', error);
            resolve(false);
          }
        );
      }, (error) => {
        console.log(this.tag, 'ERROR', error);
        this.isAlertShowing = true;
        this.alertReaderError.present();
      });
    });
  }

  // Called every time we do a reader operation
  isReaderConnected(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.readerService.isConnected().subscribe(
        (result) => {
          console.log(this.tag, 'Reader is connected', result);
          if (result) {
            observer.next(true); // Connected
          } else {
            observer.error('Reader not connected'); // Not connected
          }
        },
        (error) => {
          observer.error('Reader not connected'); // Not connected
        }
      );
    });
  }

  initReaderInventory() {

    this.simulateTriggerReleased(true);

    //if (this.platform.is('cordova')) {
    console.log(this.tag, 'Initializing inventory', this.toSearchInventoryList);
    this.readerService.initInventory(this.toSearchInventoryList).subscribe(
      (tagResponse: TagReadResponse) => {
        // Tag read
        if (this.isInventory) {
          this.processTagInventory(tagResponse);
        } else {
          this.processTag(tagResponse);
        }
      }, (error) => {
        console.log(this.tag, 'ERROR Reader RFID', error);
        this.isAlertShowing = true;
        this.alertReaderError.present();
      }
    );

    this.initReaderTriggerListener();

    if (this.simulatorService.isSimulatorEnabled) {
      this.timerTriggerPulled = setTimeout(() => {
        this.simulateTriggerPulled();
      }, 2000);
    }
  }

  initReaderGeiger(tag: CycleCountRemainingItem) {
    if (tag.UPCs) {
      this.initInventoryMode(tag.UPCs.split('|').concat(tag.EPCs.split('|'))); // Search by UPCs + EPCs
    } else if (tag.EPCs) {
      if (tag.EPCs.split('|').length > 1) {
        this.initInventoryMode(tag.EPCs.split('|')); // Search by EPCs
      } else { // If only one tag is sent, then init geiger mode with that tag
        console.log(this.tag, 'Initializing geiger for tag', tag.EPCs);
        this.initReaderGeigerSingleTag(tag.EPCs); // Search a single EPC
      }
    }
    this.initReaderTriggerListener();
  }

  initReaderGeigerSingleTag(tag: string) {

    this.isGeiger = true;

    if (this.loading) {
      this.isAlertShowing = false;
      this.loading.dismiss();
    }

    console.log(this.tag, 'Initializing Geiger');
    this.initShowGeigerPopover(tag);

    // Init trigger listener to reset the proximity when trigger released
    this.initReaderTriggerListener();

    if (this.simulatorService.isSimulatorEnabled) {
      this.timerTriggerPulled = setTimeout(() => {
        this.simulateTriggerPulled();
      }, 800);
    }

    this.readerService.initGeiger(tag).subscribe(
      (tagResponse: TagReadResponse) => {
        // Tag read
        // console.log(this.tag, 'RSSI: ', tagResponse.rssiPercentage);
        this.processTagGeiger(tagResponse);
      }, (error) => {
        console.log(this.tag, 'ERROR Geiger', error);
        this.isAlertShowing = true;
        this.alertReaderError.present();
      }
    );
  }

  initInventoryMode(epcUpcList: Array<string>) {
    this.initLoader('cycle_count.loading.searching_inventory', () => {
      this.cancelInventory().then(() => {
        this.simulateTriggerReleased();
      });
    });
    this.isInventory = true;
    this.toSearchInventoryList = epcUpcList;
    console.log(this.tag, 'Inventory List:', this.toSearchInventoryList);
    this.initReaderInventory();
  }

  cancelInventory(): Promise<any> {
    return new Promise<any>((resolve) => {
      // When the trigger is released, if in inventory mode, then change to normal mode and dismiss loading
      if (this.isInventory) {
        this.isInventory = false;
        clearTimeout(this.timerTriggerPulled);
        if (!this.isGeiger) {
          this.initReaderRFID();
        }
        resolve();
      }
    });
  }

  resetGeiger() {
    this.readerService.tagProximity = 0;
    this.cdr.detectChanges();
  }

  simulateTriggerPulled() {
    console.log(this.tag, 'Trigger is pulling');
    this.isTriggerPulled = true;
    this.cdr.detectChanges();
    this.readerService.simulateTriggerPress().subscribe(
      (response) => {
        console.log(this.tag, 'Trigger Pulled', response);
      },
      (error) => {
        console.log(this.tag, 'Trigger Pull error', error);
      }
    );
    this.initReaderTriggerListener();
  }

  simulateTriggerReleased(skipReader?: boolean) {
    console.log(this.tag, 'Trigger is releasing');
    this.isTriggerPulled = false;
    this.cdr.detectChanges();
    if (!skipReader) {
      this.readerService.simulateTriggerRelease().subscribe(
        (response) => {
          console.log(this.tag, 'Trigger Released', response);
        },
        (error) => {
          console.log(this.tag, 'Trigger Release error', error);
        }
      );
    }
    this.initReaderTriggerListener();
  }

  purgeTags() {
    console.log(this.tag, 'Calling Purge tags');
    this.readerService.purgeTags().subscribe();
  }

  toggleTrigger() {
    if (this.isTriggerPulled) {
      this.simulateTriggerReleased();
      this.refreshRemainingList();
    } else {
      this.simulateTriggerPulled();
    }
  }

  stopReader() {
    this.isReaderConnected().subscribe(() => {
      if (this.platform.is('cordova')) {
        this.readerService.stopScanCC().subscribe(
          () => {
            console.log(this.tag, 'Reader stopped successfully');
          },
          (error) => {
            console.log(this.tag, 'Error stopping reader', error);
          }
        );
      }
    }, (error) => {
      console.log(this.tag, 'ERROR', error);
    });
  }

  /**
   *
   *    SAVE CYCLE COUNT
   *
   */

  private saveCycleCount(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.stopReader(); // Stop reader to prevent new tags when saving

      let timestamp = this.vizixService.vizixTime();

      let tagsToUpload: LastDetectTag[] = [];

      let concatTags = this.tagsToSync;

      // Add the values for lastDetectTime
      for (let tag of concatTags) {
        tagsToUpload.push(new LastDetectTag(tag, this.lastDetectTime.get(tag)))
      }
      this.tagsToSync = [];

      let tagsToUploadCount = tagsToUpload.length;

      if (tagsToUpload.length > 0) {
        this.initShowProgressPopover();

        let errorCount = 0;

        this.vizixEventService.getVizixEventItemBase().then((event) => {
          console.log(this.tag, 'Base Cycle Count Event', event);

          this.generateAndSaveVizixEvent(VizixEventAction.START,
            VizixEventActivity.SYNC,
            'Sync Started',
            VIZIX_EVENT_ID_START_CYCLE_COUNT,
            tagsToUploadCount, false, null, null, null, timestamp);
          const zoneToSync = String(this.vizixService.getStoreId()) + '_' + this.selectedZone.zoneTypeCode;
          this.cycleCountService.uploadCycleCount(tagsToUpload, zoneToSync, event.user, event.remoteSource, timestamp).subscribe(
            (response) => {
              console.log(this.tag, 'Percentage received: ', response.progress);
              errorCount += response.errorCount;
            },
            (error: ErrorResponse) => {
              console.log(this.tag, 'Error uploading CycleCount', error);

              this.cycleCountService.resetUploadProgress();

              if (this.popoverProgress) {
                this.isAlertShowing = false;
                this.popoverProgress.dismiss();
              }
              this.isAlertShowing = true;

              this.showUploadErrorAlert(error);

              // Record the end of a cyclecount
              console.log(this.tag, 'Saving END Event (From Error)', tagsToUploadCount);
              this.generateAndSaveVizixEvent(VizixEventAction.END,
                VizixEventActivity.SYNC,
                null,
                VIZIX_EVENT_ID_END_CYCLE_COUNT,
                tagsToUploadCount,
                true, error.message);

            },
            () => {

              let bridgeCode: string;
              let thingTypeCode: string;

              // Record the end of processing if thingBridge
              if (this.vizixService.configurationApp.CycleCountConfiguration.EndPointMode.value == END_POINT_MODE_THING_BRIDGE) {
                bridgeCode = this.vizixService.configurationApp.CycleCountConfiguration.BridgeCode.value;
              }

              console.log(this.tag, 'Saving END Processing Event', tagsToUploadCount);
              this.generateAndSaveVizixEvent(VizixEventAction.PROCESSED,
                VizixEventActivity.SYNC,
                null,
                VIZIX_EVENT_ID_PROCESSING_CYCLE_COUNT,
                tagsToUploadCount,
                null,
                null,
                bridgeCode,
                THING_TYPE_VIZIX_EVENT, timestamp);

              // Record the end of a cyclecount
              console.log(this.tag, 'Saving END Event', tagsToUploadCount);
              this.generateAndSaveVizixEvent(VizixEventAction.END,
                VizixEventActivity.SYNC,
                null,
                VIZIX_EVENT_ID_END_CYCLE_COUNT,
                tagsToUploadCount, false, null, null, null, timestamp);

              if (this.popoverProgress) {
                this.isAlertShowing = false;
                this.popoverProgress.dismiss();
              }
              if (errorCount > 0) {
                this.initAlertIncompleteUploadError(errorCount);
                this.isAlertShowing = true;
                this.alertIncompleteUploadError.present();
              }
              resolve(true);
            }
          );
        }, () => {
          console.log(this.tag, 'Error getting VizixEventBase');
          reject();
        });
      } else {
        reject();
      }
    });
  }

  openSelectedFilters() {
    let selectedFiltersString: string = '';
    this.selectedFilters.forEach((selectedFilter) => {
      selectedFiltersString += '<p>' + selectedFilter.label + ': ' + selectedFilter.value + '</p>';
    });

    let alert = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.selected_filters.title'),
      message: selectedFiltersString.trim(),
      buttons: [{
        text: this.translate.instant('cycle_count.alerts.selected_filters.ok'),
        handler: () => {
          this.isAlertShowing = false;
        }
      }]
    });
    this.isAlertShowing = true;
    alert.present();
  }

  processTagInventory(tagResponse: TagReadResponse) {
    // console.log(this.tag, 'TAG (Inventory): ', tagResponse);
    // First we check if the tag is SGTIN or GTIN
    if (tagResponse.upc) { // SGTIN
      let formattedUpc = this.padUpc.transform(tagResponse.upc);
      for (let tag of this.toSearchInventoryList) {
        if (tag == formattedUpc) {
          console.log(this.tag, 'Item found!', tagResponse.value);
          this.initReaderGeiger(new CycleCountRemainingItem().fromSingleEpc(tagResponse.value)); // Always search by EPC returned by the reader
        }
      }
    } else if (tagResponse.value) { // GTIN
      for (let tag of this.toSearchInventoryList) {
        if (tag == tagResponse.value) {
          console.log(this.tag, 'Item found!', tagResponse.value);
          this.initReaderGeiger(new CycleCountRemainingItem().fromSingleEpc(tagResponse.value)); // Always search by EPC returned by the reader
        }
      }
    }
  }

  processTagGeiger(tagResponse: TagReadResponse) {
    // console.log(this.tag, 'GEIGER: ', tagResponse);
  }

  isTagToIgnore(searchTag: string) {
    // console.log(this.tag, 'OK 2', this.totalReadsList.indexOf(searchTag) > -1);
    return this.totalReadsList.indexOf(searchTag) > -1 || this.oversList.indexOf(searchTag) > -1;
  }

  updateQuantityOnHands(sku: string) {
    let updated = false;
    for (let group of this.remainingItemGroupArray) {
      for (let item of group.itemList) {
        if (item.SKU && item.SKU == sku) {
          item.QtyOnHand -= 1;
          group.GroupQty -= 1;
          this.qtyMap.set(sku, item.QtyOnHand);

          // Delete item if Qty = 0
          if (item.QtyOnHand == 0) {
            group.itemList.splice(group.itemList.indexOf(item), 1);
          }
          // Delete Group if GroupQty = 0
          if (group.GroupQty == 0) {
            this.remainingItemGroupArray.splice(this.remainingItemGroupArray.indexOf(group), 1);
          }
          updated = true;
          break;
        }
      }
      if (updated) break;
    }
  }

  hasQuantityOnHands(sku: string): boolean {
    return this.qtyMap != null && this.qtyMap.has(sku) && this.qtyMap.get(sku) > 0;
  }

  readClick() {
    // if (this.knownTags.length > 0) {
    //   this.initShowPopover(this.translate.instant('cycle_count.read') + ' (' + this.knownTags.length + '):', this.knownTags);
    // }
  }

  totalReadClick() {
    // if ((this.knownTags.length + this.initialTotalReadsList.length) > 0) {
    //   this.initShowPopover(this.translate.instant('cycle_count.total_reads') + ' (' + this.knownTags.concat(this.initialTotalReadsList).length + '):', this.knownTags.concat(this.initialTotalReadsList));
    // }
  }

  remainingClick() {
    this.slides.slideTo(1);
  }

  expectedClick() {
    // Do nothing
  }

  refreshRemainingList() {
    if (!this.isTriggerPulled) {
      console.log(this.tag, 'Ordering remaining groups');
      this.remainingItemGroupArray.sort((remainingItemGroup1, remainingItemGroup2) => {
        if (remainingItemGroup1.GroupQty > remainingItemGroup2.GroupQty) {
          return -1;
        }

        if (remainingItemGroup1.GroupQty < remainingItemGroup2.GroupQty) {
          return 1;
        }

        return 0;
      });
      console.log(this.tag, 'Ordering remaining items for each group');
      for (let remainingItemGroup of this.remainingItemGroupArray) {
        remainingItemGroup.itemList.sort((remainingItem1, remainingItem2) => {
          if (remainingItem1.QtyOnHand > remainingItem2.QtyOnHand) {
            return -1;
          }

          if (remainingItem1.QtyOnHand < remainingItem2.QtyOnHand) {
            return 1;
          }

          return 0;
        });
      }

      this.remainingItemGroupArrayToShow = [];
      let remainingItemGroupArrayToShowTemp: CycleCountRemainingGroup[] = [];

      for (let remainingItemGroup of this.remainingItemGroupArray) {
        remainingItemGroupArrayToShowTemp.push(remainingItemGroup.clone());
      }

      for (let remainingItemGroupTemp of remainingItemGroupArrayToShowTemp) {
        remainingItemGroupTemp.itemList =
          remainingItemGroupTemp.itemList.slice(
            remainingItemGroupTemp.page * PAGE_SIZE,
            (remainingItemGroupTemp.page + 2) * PAGE_SIZE);
      }

      this.remainingItemGroupArrayToShow = remainingItemGroupArrayToShowTemp;
      this.cdr.detectChanges();
    }
  }

  unsubscribeAll() {
    if (this.readerDisconnectSubscription) {
      this.readerDisconnectSubscription.unsubscribe();
    }
    if (this.triggerListenerSubscription) {
      this.triggerListenerSubscription.unsubscribe();
    }
  }


  initShowDetailsPopover(title: string, tag: string, showGeigerButton?: boolean, callback?) {
    // Initialize popoverDetails with the new product status list and the current status
    this.popoverDetails = this.popoverCtrl.create(PopoverDetailsPage,
      {
        title: title,
        tag: tag,
        isImageAviable: true,
        showGeigerButton: true
      }, {showBackdrop: true, cssClass: 'details-popover'});
    this.showDim = true;
    this.loading.dismiss();
    this.popoverDetails.present(); // Without event {ev: event}, the popoverDetails shows in the middle
    this.isAlertShowing = true;
    this.popoverDetails.onWillDismiss(initGeiger => {
      this.showDim = false;
      this.isAlertShowing = false;
      if (callback && initGeiger) {
        callback(initGeiger);
      }
    });
  }

  onSlideReachEnd(slider: Slides) {
    // console.log(this.tag, 'Slide reached end');
    this.isFirstSlideShowing = false;
    this.simulateTriggerReleased();
    this.refreshRemainingList();
  }

  // Triggered when the slide starts to move to the remaining slide
  onSlideReachStart(slider: Slides) {
    // console.log(this.tag, 'Slide reached start');
    this.isFirstSlideShowing = true;
  }

  onScrollDownGroup(group: CycleCountRemainingGroup) {
    if (group.page < group.pageMax) {

      // Add the next page
      for (let groupOriginal of this.remainingItemGroupArray) {
        if (group.Group == groupOriginal.Group) {
          group.itemList =
            group.itemList.concat(groupOriginal.itemList.slice(
              (group.page + 2) * PAGE_SIZE,
              (group.page + 3) * PAGE_SIZE));
          break;
        }
      }

      group.page += 1;
      // console.log("group final",JSON.parse(JSON.stringify(group)));

      // this.cdr.detectChanges();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/cycle-count/cycle-count.detail.ts